import about from "./About.module.css";
import CETClock from "../../components/about/Clock";
import Review from "../../components/about/review/Review";
import reviews from "../../data/AboutData";
import { BehanceLogo, DownloadSimple, Envelope, LinkedinLogo } from "phosphor-react";

function About() {
    const scrollSpeedPerCard = 5; // seconds per card
    const scrollDuration = `${reviews.length * scrollSpeedPerCard}s`;

    return (
        <main id="about" className={about.about}>
            <h1 className={about.title}>ABOUT<span> ME</span></h1>
            <div className={about["bento-container"]}>
                <div className={`${about["bento-item"]} ${about.aboutTXT}`}>
                    <p><strong>Hey there!</strong> 👋 I'm Kian, a designer with a passion for bold visuals, sleek interfaces, and making things look way cooler than they did before. 🎨✨ Since 2019, I've been helping brands and startups turn ideas into high-impact, user-friendly designs that stand out. <br /><br />
                    I specialize in <strong>UI/UX design, branding, and design systems</strong>, helping brands and startups turn ideas into <strong>high-impact, memorable experiences</strong>. 🚀<br /><br />
                    I thrive on creating designs that are not just visually striking but also <strong>functional and user-friendly</strong>. Whether it's crafting intuitive interfaces, building brand identities, or refining messy design systems, I make sure every pixel has a purpose. 🛠️💡<br /><br />
                    I've worked with startups and teams to build <strong>scalable, engaging designs</strong> that drive results. When I'm not pushing pixels, you'll probably find me <strong>refining my hacker skills</strong> 🧑‍💻, obsessing over typography choices (yes, fonts do matter), or convincing myself that browsing design inspo totally counts as “research.” 🔥</p>
                </div>
                <div className={`${about["bento-item"]} ${about.socials}`}>
                    <a href="https://behance.net/kiansegantini" target="_blank" rel="noreferrer" className={about.social}><BehanceLogo weight="thin" className={about.icon}/></a>
                    <a href="https://linkedin.com/in/kian-segantini" target="_blank" rel="noreferrer" className={about.social}><LinkedinLogo weight="thin" className={about.icon}/></a>
                    <a href="mailto:kiansegantini@gmail.com" target="_blank" rel="noreferrer" className={about.social}><Envelope weight="thin" className={about.icon}/></a>
                </div>
                <div className={`${about["bento-item"]} ${about.interests}`}>
                    When I'm not designing, you'll find me staying active — whether it's hitting the gym, running, or tearing up trails on my MTB. 🚴‍♂️🏃‍♂️ But my true element? The water. 🌊 There's where I feel at home. I love exploring and doing crazy stuff, because why not? 🤪 When I'm not moving, I'm reading or lost in music — because life needs a soundtrack. 🎧📖
                </div>
                <a href="/resume" className={`${about["bento-item"]} ${about.cv}`}>DOWNLOAD MY CV <DownloadSimple className={about.download}/></a>
                <a href="/resume" className={`${about["bento-item"]} ${about.mobileCV}`}>READ MY CV <DownloadSimple className={about.download}/></a>
                <div className={`${about["bento-item"]} ${about.time}`}>
                    <CETClock />
                </div>
                <div className={`${about["bento-item"]} ${about.thanks}`}>THANK YOU</div>
                <div className={`${about["bento-item"]} ${about.testimonials}`} style={{ '--scroll-duration': scrollDuration }}>
                    <ul>
                        {reviews.map((review, index) =>
                            <Review 
                                key={index}
                                pfp={review.pfp}
                                name={review.name}
                                position={review.position}
                                p={review.p}
                                width={review.width}
                            />
                        )}
                    </ul>
                    <ul aria-hidden="true">
                        {reviews.map((review, index) =>
                                <Review 
                                    key={index}
                                    pfp={review.pfp}
                                    name={review.name}
                                    position={review.position}
                                    p={review.p}
                                    width={review.width}
                                />
                        )}
                    </ul>
                    <div className={about.shadow1}></div>
                    <div className={about.shadow2}></div>
                </div>
            </div>
        </main>
    );
}

export default About;
